import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatDialog, MatSnackBar, MatTableDataSource, } from '@angular/material';
import { ModalConfirmComponent } from '../../../../../components/modal-confirm/modal-confirm.component';
var ClientAddressListComponent = /** @class */ (function () {
    function ClientAddressListComponent(route, authService, snackBar, dialog, location, router) {
        this.route = route;
        this.authService = authService;
        this.snackBar = snackBar;
        this.dialog = dialog;
        this.location = location;
        this.router = router;
        this.headersTable = ['addressTitle', 'address', 'kind', 'actions'];
        this.params = { formGroupValue: [] };
    }
    ClientAddressListComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.queryParams.subscribe(function (params) {
            _this.params.formGroupValue = params.formGroupValue;
        });
        this.customerID = this.route.snapshot.paramMap.get('customerID');
        this.authService.customerUserInfo(this.customerID).subscribe(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.customer = response.firstName + ' ' + response.lastName;
                return [2 /*return*/];
            });
        }); }, function (error) {
            _this.snackBar.open(error.error.message);
        });
        this.clientAddressList();
    };
    ClientAddressListComponent.prototype.clientAddressList = function () {
        var _this = this;
        this.authService.clientAddressList(this.customerID).then(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.dataSource = new MatTableDataSource(response);
                return [2 /*return*/];
            });
        }); }, function (error) {
            _this.snackBar.open(error.error.message);
        });
    };
    ClientAddressListComponent.prototype.convertKind = function (kind) {
        switch (kind) {
            case 'HOME':
                return 'Residencial';
                break;
            case 'COMPANY':
                return 'Comercial';
                break;
            default:
                return '';
        }
    };
    ClientAddressListComponent.prototype.goBack = function () {
        this.location.back();
    };
    ClientAddressListComponent.prototype.remove = function (id) {
        var _this = this;
        this.dialog
            .open(ModalConfirmComponent, {
            width: '500px',
            data: {
                text: 'Deseja remover esse endereço?',
                buttonConfirmText: 'Remover',
            },
        })
            .afterClosed()
            .toPromise()
            .then(function (result) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                if (result && result !== 'cancel') {
                    return [2 /*return*/, this.authService.delete(id, this.customerID).then(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            return tslib_1.__generator(this, function (_a) {
                                this.clientAddressList();
                                this.snackBar.open('Endereço removido com sucesso.');
                                return [2 /*return*/];
                            });
                        }); }, function (error) {
                            _this.snackBar.open(error.error.message);
                        })];
                }
                return [2 /*return*/];
            });
        }); })
            .catch(function (err) {
            _this.snackBar.open(err.message);
        });
    };
    return ClientAddressListComponent;
}());
export { ClientAddressListComponent };
